import { render, staticRenderFns } from "./GlobalAddTaskModal.vue?vue&type=template&id=0fdb2169&scoped=true&"
import script from "./GlobalAddTaskModal.vue?vue&type=script&lang=js&"
export * from "./GlobalAddTaskModal.vue?vue&type=script&lang=js&"
import style0 from "./GlobalAddTaskModal.vue?vue&type=style&index=0&id=0fdb2169&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdb2169",
  null
  
)

export default component.exports